var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('box',{ref:_vm.boxRef,attrs:{"title":"自动匹配","width":1000,"index":4,"moduleName":"goods","group":"purchase_goods","pagerConfig":_vm.pagerConfig,"store":_vm.store,"selectType":"checkbox"},on:{"hide":_vm.hide,"submit":_vm.submit,"boxdataload":_vm.boxdataload}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }